<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t9lUkv/images/cover.jpg?1684515369304" alt="This image is the cover for the book Amar significa… No avergonzarse, Amar significa…"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amar significa… No avergonzarse, Amar significa…
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Amar significa… una historia</i></b></p><p>Geoff vive en la ciudad, aprovechando la marcha gay al máximo, cuando la muerte de su padre le obliga a volver a la granja familiar. Allí conocerá a un joven Amish dormido en el establo y Geoff averiguará que el muchacho está en su Rumspringa, el año que los jóvenes Amish pasan fuera de la Comunidad antes de aceptar su bautismo en la Iglesia. A pesar de su mutua atracción, Geoff está empeñado en no liarse con él. Sin embargo Eli se ha dado cuenta que Geoff comparte sus sentimientos y comienza a cortejarle, capturando la atención de Geoff y, por supuesto, sus sentimientos.</p> <p>Su relación se verá amenazada por familiares de mente estrecha y los chismorreos de la sociedad en general. Un nuevo mundo se abre para Eli, que tendrá que decidir si quiere volver a la Comunidad con su familia, al mundo en el que sabe cómo será su futuro, o se quedará con Geoff y tendrá fe en el poder del amor.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Grey, Saura Garcia
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1182b70e